import { render, staticRenderFns } from "./GnbWrap.vue?vue&type=template&id=62d43aab&scoped=true&"
import script from "./GnbWrap.vue?vue&type=script&lang=ts&"
export * from "./GnbWrap.vue?vue&type=script&lang=ts&"
import style0 from "./GnbWrap.vue?vue&type=style&index=0&id=62d43aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d43aab",
  null
  
)

export default component.exports